import(/* webpackMode: "eager" */ "/app/app/blogs/play/page.tsx");
